import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { Dialog, Typography, Button } from "@mui/material";

import { useUsers } from "hooks";
import { appRoutes } from "routes";
import JoinLogo from "assets/images/Join.png";
import TemplateGroupPresenter from "presenters/TemplateGroupPresenter";
import UserPresenter from "presenters/UserPresenter";
import SpinningCloseButton from "components/SpinningCloseButton";

import useStyles from "./useStyles";

const JoinModal = (props) => {
  const { templateGroup, onClose } = props;
  const { currentUser } = useUsers();
  const classes = useStyles();

  const redirectRoute = UserPresenter.isRegistered(currentUser)
    ? appRoutes.paymentPath()
    : { pathname: appRoutes.signUpPath(), state: { templateGroup: TemplateGroupPresenter.id(templateGroup) } };

  return (
    <Dialog
      classes={{ root: classes.root }}
      PaperProps={{ classes: { root: classes.paper } }}
      open
      onBackdropClick={() => onClose()}
    >
      <SpinningCloseButton onClick={() => onClose()} />

      <img src={JoinLogo} alt="Join JibJab Today" className={classes.logo} />
      <Typography component="p" variant="h2" fontWeight="Regular" align="center" className={classes.description}>
        You must be a premium JibJab Member to access and share Ecards and Invites.
      </Typography>
      <Button
        variant="contained"
        size="large"
        color="primary"
        component={NavLink}
        to={redirectRoute}
        onClick={() => onClose()}
      >
        JOIN JIBJAB
      </Button>
    </Dialog>
  );
};

JoinModal.propTypes = {
  templateGroup: TemplateGroupPresenter.shape(),
  onClose: PropTypes.func.isRequired,
};

export default JoinModal;
